/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Edit_TitleInputs */

const en_admin_categories_edit_title = /** @type {(inputs: Admin_Categories_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Category`)
};

const zh_admin_categories_edit_title = /** @type {(inputs: Admin_Categories_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑分类`)
};

/**
* | output |
* | --- |
* | "Edit Category" |
*
* @param {Admin_Categories_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_edit_title = /** @type {((inputs?: Admin_Categories_Edit_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Edit_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_edit_title(inputs)
	return zh_admin_categories_edit_title(inputs)
});
export { admin_categories_edit_title as "admin.categories.edit_title" }